import { deepSignal } from "deepsignal";
import { useEffect } from "preact/hooks";

export interface TwitchConfigType {
  twitchUsername: string | null;
  twitchAccessToken: string | null;
  twitchRefreshToken: string | null;
  twitchBroadcasterID: string | null;
  twitchCampaignID: string | null;
  twitchCampaignGoal: string | null;
  twitchCampaignName: string | null;
}

export const TwitchConfig: TwitchConfigType = {
  twitchUsername: "",
  twitchAccessToken: "",
  twitchRefreshToken: "",
  twitchBroadcasterID: "",
  twitchCampaignID: "",
  twitchCampaignGoal: "0.00",
  twitchCampaignName: "",
};

const twitchConfig = deepSignal(TwitchConfig);

const useTwitchConfig = () => {
  useEffect(() => {
    Object.keys(twitchConfig).forEach((key) => {
      const validKey = key as keyof TwitchConfigType;
      twitchConfig[validKey] = localStorage.getItem(validKey) ?? twitchConfig[validKey] ?? null;
    });
  });

  return twitchConfig;
};

export default useTwitchConfig;
